import * as React from 'react';
import { Badge, badgeVariants } from './badge';

type SeparationStatus = 'BORRADOR' | 'GENERADA' | 'CORREGIDA' | 'ANULADA' | 'DESCARTADA';
type UnitStatus = 'DISPONIBLE' | 'SEPARADA' | 'VENDIDA';
type ProjectStatus = 'SIN_CATALOGO' | 'ACTIVO' | 'CERRADO';
type InmobiliariaStatus = 'ACTIVA' | 'INACTIVA';

const statusConfig = {
  // Separation
  BORRADOR: { label: 'Borrador', variant: 'secondary' as const },
  GENERADA: { label: 'Generada', variant: 'success' as const },
  CORREGIDA: { label: 'Corregida', variant: 'warning' as const },
  ANULADA: { label: 'Anulada', variant: 'destructive' as const },
  DESCARTADA: { label: 'Descartada', variant: 'outline' as const },
  // Unit
  DISPONIBLE: { label: 'Disponible', variant: 'success' as const },
  SEPARADA: { label: 'Separada', variant: 'warning' as const },
  VENDIDA: { label: 'Vendida', variant: 'default' as const },
  // Project
  SIN_CATALOGO: { label: 'Sin catálogo', variant: 'secondary' as const },
  ACTIVO: { label: 'Activo', variant: 'success' as const },
  CERRADO: { label: 'Cerrado', variant: 'outline' as const },
  // Inmobiliaria
  ACTIVA: { label: 'Activa', variant: 'success' as const },
  INACTIVA: { label: 'Inactiva', variant: 'outline' as const },
} as const;

type StatusKey = keyof typeof statusConfig;

interface StatusBadgeProps {
  status: StatusKey;
  className?: string;
}

const StatusBadge = ({ status, className }: StatusBadgeProps) => {
  const config = statusConfig[status] ?? { label: status, variant: 'default' as const };
  return <Badge variant={config.variant} className={className}>{config.label}</Badge>;
};

export { StatusBadge, statusConfig };
export type { SeparationStatus, UnitStatus, ProjectStatus, InmobiliariaStatus, StatusKey };